import React, { useState } from 'react';
import {
  Card,
  CardContent,
  Typography,
  TextField,
  Button,
  Stack,
} from '@mui/material';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import ExploreIcon from '@mui/icons-material/Explore';

const Locations = () => {
  const [search, setSearch] = useState('');

  const venues = [
    {
      name: '📍 Stade Linite',
      address: 'Roche Caiman, Mahé',
      sports: ['Football', 'Athletics', 'Opening/Closing Ceremonies'],
    },
    {
      name: '📍 Gymnase De Victoria',
      address: 'Victoria, Mahé',
      sports: ['Basketball'],
    },
    {
      name: '📍 La Promenade Gymnasium',
      address: 'La Promenade Gymnasium, Seychelles',
      sports: ['Badminton'],
    },
    {
      name: '📍 Seychelles National Pool',
      address: 'Roche Caiman, Mahé',
      sports: ['Swimming'],
    },
    {
      name: '📍 Roche Caiman Gymnasium',
      address: 'Roche Caiman Gymnasium, Seychelles',
      sports: ['Boxing'],
    },
    {
      name: '📍 Palais De Sport',
      address: 'Palais De Sport, Roche Caiman, Seychelles',
      sports: ['Volleyball'],
    },
        {
      name: '📍 Hotel Eden Bleu',
      address: 'Hotel Eden Blue, Eden Plaza, Seychelles',
      sports: ['Volet Jeunesse', 'eSport'],
    },
    {
      name: '📍 Paradise Arena',
      address: 'Paradise Arena, Seychelles',
      sports: ['Beach Soccer'],
    },
    {
      name: '📍 Roche Caiman',
      address: 'Roche Caiman, Seychelles',
      sports: ['Sailing'],
    },
    {
      name: '📍 Astro Turf',
      address: 'Astro Turf, Roche Caiman, Seychelles',
      sports: ['Football'],
    },
  ];

  const filteredVenues = venues.filter(
    (venue) =>
      venue.name.toLowerCase().includes(search.toLowerCase()) ||
      venue.address.toLowerCase().includes(search.toLowerCase()) ||
      venue.sports.some((sport) =>
        sport.toLowerCase().includes(search.toLowerCase())
      )
  );

  return (
    <>
      <Typography
        variant="h4"
        gutterBottom
        sx={{ color: 'textSecondary', fontWeight: 'bold', mb: 4, mt:3, color: 'white' }}
      >
        <LocationOnIcon sx={{ fontSize: 40}} /> Sites sportifs
      </Typography>

      <TextField
        fullWidth
        variant="outlined"
        label="Rechercher des lieux ou des sports..."
        value={search}
        onChange={(e) => setSearch(e.target.value)}
        InputLabelProps={{
          sx: { color: 'white' },
        }}
        InputProps={{
          sx: {
            color: 'white',
            '& .MuiOutlinedInput-notchedOutline': {
              borderColor: 'white',
            },
            '&:hover .MuiOutlinedInput-notchedOutline': {
              borderColor: 'white',
            },
            '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
              borderColor: 'white',
            },
          },
        }}
        sx={{
          mb: 3,
          px:1
        }}
      />


      <Card sx={{ backgroundColor: 'rgba(255,255,255,0.98)' }}>
        <CardContent>
          <Stack spacing={3}>
            {filteredVenues.map((venue, index) => (
              <div key={index} className="border-b pb-2">
                <Typography variant="subtitle1" fontWeight="bold">
                  {venue.name}
                </Typography>
                <Typography variant="body2" color="textSecondary">
                  {venue.address}
                </Typography>
                <Typography variant="body2" color="textSecondary" sx={{ mb: 1 }}>
                  Sports: {venue.sports.join(', ')}
                </Typography>
                <Button
                  variant="contained"
                  sx={{  backgroundColor: 'rgb(0,127,255)', color: 'white', fontWeight: 'bold' }}
                  size="small"
                  href={`https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(
                    venue.name + ', ' + venue.address
                  )}`}
                  target="_blank"
                >
                  See Location <ExploreIcon sx={{ ml: 1 }} />
                </Button>
              </div>
            ))}
          </Stack>
        </CardContent>
      </Card>
      <br/>
      <br/>
    </>
  );
};

export default Locations;
